import styled, { css } from 'styled-components';

export const Counter = styled.span`
  color: #999;
  font-size: 12px;
  /* if className props are passed in render the styles */
  ${({ className }) =>
    className &&
    css`
      ${className};
    `}
`;
